/**
 * TariffsDesktop — десктоп-раскладка «Тарифов»: sticky-шапка (+«История
 * изменений»), блоки Соло и Клиника с инлайн-правкой. Состояние правки и
 * запросы держит оркестратор Tariffs.
 */

import {History} from 'lucide-react';

import type {SaveClinicInput, TariffsBundle} from '@services/tariffs';
import {Button} from '@components/ui/Button';
import {Loader} from '@components/ui/Loader';

import {ClinicCard} from '../ClinicCard';
import {SoloCard} from '../SoloCard';
import {TrialFeaturesCard} from '../TrialFeaturesCard';

type TariffsDesktopProps = {
  data?: TariffsBundle;
  isLoading: boolean;
  editing: 'solo' | 'clinic' | null;
  onEditSolo: () => void;
  onEditClinic: () => void;
  onCancel: () => void;
  onAskSaveSolo: (price: number) => void;
  onAskSaveClinic: (input: SaveClinicInput) => void;
  onOpenHistory: () => void;
  onNotify: (message: string) => void;
};

export const TariffsDesktop = ({
  data,
  isLoading,
  editing,
  onEditSolo,
  onEditClinic,
  onCancel,
  onAskSaveSolo,
  onAskSaveClinic,
  onOpenHistory,
  onNotify,
}: TariffsDesktopProps) => (
  <>
    <header className="sticky top-0 z-10 flex items-center gap-4 border-b border-skr-line bg-background/80 px-[30px] py-[18px] backdrop-blur">
      <div className="min-w-0 flex-1">
        <h1 className="text-[21px] font-bold -tracking-[.02em]">Тарифы</h1>
        <div className="mt-0.5 text-[13px] text-muted-foreground">
          Пакеты для клиник · изменения применяются со следующего продления
        </div>
      </div>
      <Button variant="outline" onClick={onOpenHistory}>
        <History />
        История изменений
      </Button>
    </header>

    <div className="flex max-w-[1080px] flex-col gap-5 px-[30px] pb-[60px] pt-[26px]">
      {isLoading || !data ? (
        <div className="flex min-h-[440px] items-center justify-center">
          <Loader label="Загружаем тарифы…" />
        </div>
      ) : (
        <>
          <SoloCard
            solo={data.solo}
            editing={editing === 'solo'}
            onEdit={onEditSolo}
            onCancel={onCancel}
            onAskSave={onAskSaveSolo}
          />
          <ClinicCard
            clinic={data.clinic}
            editing={editing === 'clinic'}
            onEdit={onEditClinic}
            onCancel={onCancel}
            onAskSave={onAskSaveClinic}
          />
          <TrialFeaturesCard onSaved={onNotify} />
        </>
      )}
    </div>
  </>
);
